<template>
  <i :class="[useSvg ? 'pt-icon-svg' : 'pt-icon', iconname]" />
</template>

<script>
export default {
  name: 'PtIcon',

  props: {
    name: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'font',
      validator: value => value.match(/(font|svg)/)
    }
  },

  data: () => ({}),

  computed: {
    iconname() {
      return !this.name.includes('pt-') ? `pt-${this.name}` : this.name;
    },

    useSvg() {
      return this.type === 'svg';
    }
  }
};
</script>

<style lang="scss" src="./icon.scss" scoped />
